import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  error: null,
  catalog: [],
  fetchingCatalog: false,
  fetchingPackages: false,
  packages: [],
  contactSupport: false,
  createPackage: false,
  commodities: [],
  tests: [],
};

const placeOrderSlice = createSlice({
  name: "placeOrder",
  initialState,
  reducers: {
    fetchCompanyCatalog(state, action) {
      state.fetchingCatalog = true;
    },
    fetchCompanyCatalogSuccess(state, action) {
      state.catalog = action.payload.data.document;
      state.fetchingCatalog = false;
    },
    fetchCompanyCatalogFailure(state, action) {
      state.fetchingCatalog = false;
    },
    fetchPackages(state, action) {
      state.fetchingPackages = true;
    },
    fetchPackagesSuccess(state, action) {
      state.packages = action.payload.data.document;
      state.fetchingPackages = false;
    },
    fetchPackagesFailure(state, action) {
      state.fetchingPackages = false;
    },
    contactSupport(state, action) {
      state.contactSupport = true;
    },
    contactSupportSuccess(state, action) {
      state.contactSupport = false;
    },
    contactSupportFailure(state, action) {
      state.contactSupport = false;
    },
    createPackage(state, action) {
      state.createPackage = true;
    },
    createPackageSuccess(state, action) {
      state.createPackage = false;
    },
    createPackageFailure(state, action) {
      state.createPackage = false;
      state.error = action.payload.message;
    },
    initializeError(state, action) {
      state.error = null;
    },
    fetchCommodities(state, action) {
      state.loading = true;
    },
    fetchCommoditiesSuccess(state, action) {
      state.loading = false;
      state.commodities = action.payload.data.document;
    },
    fetchCommoditiesFailure(state, action) {
      state.loading = false;
    },
    fetchTests(state, action) {
      state.loading = true;
    },
    fetchTestsSuccess(state, action) {
      state.loading = false;
      state.tests = action.payload.data.document;
    },
    fetchTestsFailure(state, action) {
      state.loading = false;
    },
    initializeState(state, action) {
      state.error = null;
      state.catalog = [];
      state.fetchingCatalog = false;
      state.fetchingPackages = false;
      state.packages = [];
      state.contactSupport = false;
      state.createPackage = false;
      state.commodities = [];
      state.tests = [];
    },
  },
});

export const { actions, reducer, name: sliceKey } = placeOrderSlice;
